// extracted by mini-css-extract-plugin
module.exports = {"searchPage":"SearchPage_searchPage___DeZ6","toolbar":"SearchPage_toolbar__KlOeM"};